import React from "react";
import type { ProductFormValues } from "../Forms/AddProductModal";

interface Props {
  mappedRows: ProductFormValues[];
  submitting: boolean;
  onSubmit: () => void;
}

const StepPreview: React.FC<Props> = ({ mappedRows, submitting, onSubmit }) => (
  <div>
    <h3 className="font-semibold mb-4">Preview Import ({mappedRows.length} rows)</h3>

    <div className="max-h-64 text-left overflow-y-auto border rounded-md bg-gray-50">
      <table className="w-full text-sm">
        <thead className="bg-gray-100 sticky top-0">
          <tr>
            <th className="p-2 text-left text-xs font-semibold">Name</th>
            <th className="p-2 text-left text-xs font-semibold">Category</th>
            <th className="p-2 text-left text-xs font-semibold">Cost Price</th>
            <th className="p-2 text-left text-xs font-semibold">Selling Price</th>
            <th className="p-2 text-left text-xs font-semibold">Qty</th>
          </tr>
        </thead>
        <tbody>
          {mappedRows.slice(0, 10).map((p, index) => (
            <tr key={index} className="border-t">
              <td className="p-2">{p.name}</td>
              <td className="p-2">{p.category}</td>
              <td className="p-2">{p.cost_price}</td>
              <td className="p-2">{p.selling_price}</td>
              <td className="p-2">{p.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {mappedRows.length > 10 && (
        <p className="text-xs text-gray-400 p-2">
          Showing first 10 of {mappedRows.length} rows.
        </p>
      )}
    </div>

    <button
      onClick={onSubmit}
      disabled={submitting}
      className="mt-5 w-full bg-green-600 text-white p-3 rounded-md disabled:opacity-50"
    >
      {submitting ? "Importing…" : `Import Products (${mappedRows.length})`}
    </button>
  </div>
);

export default StepPreview;
